<template>
<router-link v-if="url && !failed" :to="{ name: 'BookView', params: { url: url }}"
  :class="{ 'section-image': banner }">
  <img :src="url" :alt="alt" class="img-fluid" decoding="async" @error="failed = true">
</router-link>
</template>
<script>
export default {
  name: 'SubjectBookImage',
  props: {
    url: String,
    alt: { type: String, default: 'Bölüm görseli' },
    banner: { type: Boolean, default: false }
  },
  data() { return { failed: false }; },
  watch: { url() { this.failed = false; } }
};
</script>
<style scoped>
.section-image { display: block; width: 100%; margin: 0 0 24px; }
.section-image img { display: block; width: 100%; height: clamp(160px, 25vw, 300px); object-fit: cover; object-position: center; border-radius: 12px; }
.section-image:focus-visible { outline: 3px solid var(--brand-primary-hover); outline-offset: 3px; border-radius: 12px; }
</style>
